import { render, staticRenderFns } from "./DialogPrivacy.vue?vue&type=template&id=66f7bfbc&"
import script from "./DialogPrivacy.vue?vue&type=script&lang=js&"
export * from "./DialogPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports